import Modal from "../../../../shared/Modal";
import Button from "../../../../shared/Button";

const RemoveAccModal = ({ visible, setVisible, submit, loading, cancel }) => {
  function handleCancelModal() {
    cancel && cancel();
    setVisible(false);
  }

  const modalFooter = (
    <>
      <Button onClick={handleCancelModal} type="alternative">
        Cancel
      </Button>
      <Button
        loading={loading}
        disabled={loading}
        onClick={submit}
        type="danger"
      >
        Remove
      </Button>
    </>
  );

  const modalContent = (
    <div className="flex w-full">
      <div className="text-sm text-gray-700">
        Are you sure you want to remove this accessory?
      </div>
    </div>
  );

  return (
    <Modal
      visible={visible}
      setVisible={setVisible}
      onClose={() => setVisible(false)}
      title="Remove Accessory"
      footer={modalFooter}
      content={modalContent}
      size="md"
      footerPosition="right"
    />
  );
};

export default RemoveAccModal;
